/*  ========================================================================
    # Components - Project Slide Card
    ========================================================================  */

import React from 'react';
import PropTypes from 'prop-types';
import useTranslation from '../hooks/useTranslation';
import bem from '../helpers/bem';
import tailwindConfig from '../../../tailwind.config';
import LazyImage from './LazyImage';
import LazySource from './LazySource';

const ProjectSlideCard = ({ customer, projectName, excerpt, image, permalink, dataOffset }) => {
  const __ = useTranslation();
  return (
    <a
      href={permalink}
      className={bem('c-project-slide-card')}
      title={customer}
      data-offset={dataOffset}
    >
      <LazyImage
        alt={image.alt}
        defaultUrl={image.sizes.large}
        placeholderUrl={image.sizes.placeholder}
        figureClass={bem('c-project-slide-card', 'image')}
      >
        <LazySource srcSet={image.sizes.large} mediaMin={tailwindConfig.theme.screens.lg} />
        <LazySource srcSet={image.sizes.medium_large} mediaMin={tailwindConfig.theme.screens.md} />
        <LazySource srcSet={image.sizes.medium} mediaMin={tailwindConfig.theme.screens.sm} />
      </LazyImage>
      <div className={bem('c-project-slide-card', 'content')}>
        <h3>
          <span
            className={bem('c-project-slide-card', 'company-name')}
            dangerouslySetInnerHTML={{ __html: customer }}
          />
          <span
            className={bem('c-project-slide-card', 'project-name')}
            dangerouslySetInnerHTML={{ __html: projectName }}
          />
        </h3>
        {excerpt && <p dangerouslySetInnerHTML={{ __html: excerpt }} />}
        <div className='c-project-slide-card__show-more c-link-with-svg c-link-with-svg--arrow-right'>
          {__('learn-more')}
        </div>
      </div>
    </a>
  );
};

ProjectSlideCard.propTypes = {
  customer: PropTypes.string,
  projectName: PropTypes.string,
  excerpt: PropTypes.string,
  image: PropTypes.object,
  permalink: PropTypes.string,
  dataOffset: PropTypes.number
};

export default ProjectSlideCard;
